import React, { FC, useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import { IIndividualInvoicePatch } from '@common/interfaces';
import './styles.scss';

interface ISendBlock {
  defaultValue?: string | string[];
  updateInvoice: (data: Partial<IIndividualInvoicePatch>) => void;
}

const SendCopy: FC<ISendBlock> = ({ defaultValue = '', updateInvoice }) => {
  const [emails, setEmails] = useState<string[]>([]);

  const { Option } = Select;
  const children = emails.map((email) => (
    <Option key={email} value={email}>
      {email}
    </Option>
  ));

  const defaultValuesArr = useMemo(
    () => (Array.isArray(defaultValue) ? defaultValue : [defaultValue]),
    [defaultValue],
  );

  useEffect(() => {
    if (defaultValue) {
      setEmails(defaultValuesArr);
    }
  }, [defaultValue, defaultValuesArr]);

  return (
    <div className="wrap">
      <Select
        className="select"
        data-testid="invoice-send-copy"
        defaultActiveFirstOption
        // @ts-ignore
        defaultValue={defaultValue ? defaultValuesArr : undefined}
        mode="tags"
        placeholder="Emails"
        onChange={(value: never) => {
          setEmails(value);
          updateInvoice({ recipients: value });
        }}
      >
        {children}
      </Select>
    </div>
  );
};

export default SendCopy;
